import HoldingHomeComponent from './holding-home-component';

/***
 * The holding home page, containing a message informing users that they must wait for admin approval.
 */
const holdingHome = angular
    .module('FacilityData.Home.HoldingHome', [])
    .component('holdingHome', HoldingHomeComponent)
    .name;

export default holdingHome;


// WEBPACK FOOTER //
// ./app/components/home/holding-home/holding-home.js